export const ROUTES = {
  AUTH: {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    MFA: '/mfa',
  },
  DASHBOARD: '/dashboard',
  PIPELINE: {
    LIST: '/procurement/pipeline',
    DETAILS: (id: string) => `/procurement/pipeline/${id}`,
  },
  REQUESTS: {
    LIST: '/requests',
    NEW: '/requests/new',
    NEW_SERVICE: '/requests/new-service',
    DETAILS: (id: string) => `/requests/${id}`,
    EDIT: (id: string) => `/requests/${id}/edit`,
  },
  APPROVALS: {
    LIST: '/approvals',
    DETAILS: (id: string) => `/approvals/${id}`,
  },
  NFA: {
    LIST: '/nfa',
    NEW: '/nfa/new',
    DETAILS: (id: string) => `/nfa/${id}`,
    EDIT: (id: string) => `/nfa/${id}/edit`,
  },
  LFA: {
    LIST: '/lfa',
    NEW: '/lfa/new',
    DETAILS: (id: string) => `/lfa/${id}`,
    EDIT: (id: string) => `/lfa/${id}/edit`,
  },
  PR: {
    LIST: '/pr',
    NEW: '/pr/new',
    DETAILS: (id: string) => `/pr/${id}`,
  },
  RFQ: {
    LIST: '/rfq',
    NEW: '/rfq/new',
    DETAILS: (id: string) => `/rfq/${id}`,
    EDIT: (id: string) => `/rfq/${id}/edit`,
  },
  VENDORS: {
    LIST: '/vendors',
    NEW: '/vendors/new',
    DETAILS: (id: string) => `/vendors/${id}`,
    EDIT: (id: string) => `/vendors/${id}/edit`,
  },
  QUOTATIONS: {
    LIST: '/quotations',
    DETAILS: (id: string) => `/quotations/${id}`,
    COMPARISON: (rfqId: string) => `/quotations/comparison/${rfqId}`,
  },
  PURCHASE_ORDERS: {
    LIST: '/purchase-orders',
    NEW: '/purchase-orders/new',
    DETAILS: (id: string) => `/purchase-orders/${id}`,
    EDIT: (id: string) => `/purchase-orders/${id}/edit`,
  },
  DELIVERIES: {
    TRACKING: '/deliveries',
  },
  GRN: {
    LIST: '/grn',
    NEW: '/grn/new',
    DETAILS: (id: string) => `/grn/${id}`,
    EDIT: (id: string) => `/grn/${id}/edit`,
  },
  INVOICES: {
    LIST: '/invoices',
    DETAILS: (id: string) => `/invoices/${id}`,
    EDIT: (id: string) => `/invoices/${id}/edit`,
  },
  PAYMENTS: {
    LIST: '/payments',
    DETAILS: (id: string) => `/payments/${id}`,
    EDIT: (id: string) => `/payments/${id}/edit`,
  },
  ANALYTICS: '/analytics',
  AI: '/ai',
  ADMIN: {
    USERS: '/admin/users',
    ROLES: '/admin/roles',
    APPROVAL_MATRIX: '/admin/approval-matrix',
    CONFIGURATION: '/admin/configuration',
  },
  AUDIT_LOGS: '/audit-logs',
  INTEGRATION_LOGS: '/integration-logs',
  SAP: {
    DASHBOARD: '/sap/dashboard',
    MATERIALS: '/sap/materials',
    VENDORS: '/sap/vendors',
    MASTERS: '/sap/masters',
    PR: '/sap/pr',
    PO: '/sap/po',
    GRN: '/sap/grn',
    INVOICES: '/sap/invoices',
    PAYMENTS: '/sap/payments',
    LOGS: '/sap/integration-logs',
    RETRY_QUEUE: '/sap/retry-queue',
    CONTROL: '/sap/simulation-control',
  },
} as const;
